import React from "react"
import { ShareButton } from "./share-button"
import * as styles from "./share-buttons.module.css"

export const ShareButtons = ({
  className = "",
  slug,
  textOrTitle,
  platforms = [],
}) => {
  return (
    <ul className={`${className} ${styles.list}`}>
      {platforms.map((name) => (
        <li key={name}>
          <ShareButton name={name} slug={slug} textOrTitle={textOrTitle} />
        </li>
      ))}
    </ul>
  )
}
